<template>
  <div v-if="visible">
    <div class="modal fade show cutover-modal" tabindex="-1" role="dialog" aria-labelledby="cutoverNoticeTitle"
         style="display: block;" @click.self="close">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="cutoverNoticeTitle">{{ $t("title") }}</h5>
            <button type="button" class="close" aria-label="Close" @click="close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="mb-0">{{ $t("text") }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-cutover" @click="close">{{ $t("buttons.ok") }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>
<script>
// SAP S4 cutover notice window: 17/Sep 00:00 until 22/Sep 08:00 Argentina time (GMT-3).
// Stored as absolute UTC instants so the notice shows in the same window for every country.
const NOTICE_START = Date.UTC(2026, 8, 17, 3, 0);
const NOTICE_END = Date.UTC(2026, 8, 22, 11, 0);
const REFRESH_INTERVAL = 60000;

// Once the user closes the notice it stays hidden until the next login, which clears this key.
export const NOTICE_DISMISSED_KEY = 'pwa-woe-cutover-notice-dismissed';

export default {
  name: "CutoverNoticeModal",
  i18n: {
    messages: {
      en: {
        title: "Important notice",
        text: "McCain is currently undergoing a system migration process. For this reason, orders placed through Thalamus between September 18 and 22 will be received as usual but will remain pending processing until the migration activities are completed. Operations will gradually return to normal by September 25. Thank you"
      },
      es: {
        title: "Aviso importante",
        text: "McCain se encuentra actualmente en un proceso de migración de sistema. Por este motivo, los pedidos ingresados a través de Thalamus entre el 18 y el 22 de septiembre serán recibidos normalmente, pero quedarán pendientes de procesamiento hasta la finalización de las actividades de migración. La operación se normalizará progresivamente hasta el 25 de septiembre. Muchas gracias."
      }
    }
  },
  data() {
    return {
      visible: false,
      timer: null
    }
  },
  mounted() {
    this.refresh();
    this.timer = setInterval(this.refresh, REFRESH_INTERVAL);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    isWithinNoticeWindow() {
      const now = Date.now();
      return now >= NOTICE_START && now < NOTICE_END;
    },
    isDismissed() {
      return sessionStorage.getItem(NOTICE_DISMISSED_KEY) === 'true';
    },
    refresh() {
      this.visible = this.isWithinNoticeWindow() && !this.isDismissed();
    },
    close() {
      sessionStorage.setItem(NOTICE_DISMISSED_KEY, 'true');
      this.visible = false;
    }
  }
}
</script>
<style scoped>
.cutover-modal .modal-body p {
  text-align: justify;
}

.cutover-modal .btn-cutover {
  background-color: #000000;
  border-color: #000000;
  color: #ffffff;
  min-width: 140px;
}

.cutover-modal .btn-cutover:hover,
.cutover-modal .btn-cutover:focus {
  background-color: #333333;
  border-color: #333333;
  color: #ffffff;
}
</style>
